import { FormControl, type IFormikFormControlProps } from './FormControl'
import {
  getFormControlProps,
  getNonFormControlProps,
} from './utils/getFormControlProps'
import { type INumberFieldProps, NumberField } from '../../elements/NumberField'

export interface IFormNumberFieldProps
  extends
    Omit<INumberFieldProps, 'name' | 'id' | 'helperText'>,
    IFormikFormControlProps {
  /** Unique identifier for analytics tracking of number form field interactions. */
  analyticsId?: string
}

export const FormNumberField = (props: IFormNumberFieldProps) => {
  const { id, name, disabled, ...formControlProps } = getFormControlProps(props)
  const numberfieldProps = getNonFormControlProps(props)

  return (
    <FormControl id={id} name={name} disabled={disabled} {...formControlProps}>
      {({ value, handleChange, handleBlur, isSubmitting, error }) => (
        <NumberField
          id={name}
          name={name}
          onValueChange={(values) => {
            const nextValue = values.floatValue ?? null

            // react-number-format also fires onValueChange for prop-driven
            // value syncs (e.g. a programmatic form reset); marking the field
            // touched on those no-op changes surfaces validation errors the
            // user never triggered.
            if (nextValue !== (value ?? null)) {
              handleChange(nextValue)
            }
          }}
          onBlur={handleBlur}
          error={error}
          value={value}
          disabled={isSubmitting || disabled}
          {...numberfieldProps}
          variant='standard'
        />
      )}
    </FormControl>
  )
}
